import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ComercializacionRoutingModule } from "./comercializacion-routing.module";
import { ComponentesModule } from "../componentes/componentes.module";
import { MedicionComponent } from "./medicion/medicion.component";
import { SeguimientoContratosComponent } from "./seguimiento-contratos/seguimiento-contratos.component";
import { ReportesComponent } from "./reportes/reportes.component";
import { CuentasComponent } from "./cuentas/cuentas.component";
import { ContratosComponent } from "./contratos/contratos.component";
import { EjecucionComponent } from "./ejecucion/ejecucion.component";

import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from "primeng/dropdown";


@NgModule({
  declarations: [
    MedicionComponent,
    SeguimientoContratosComponent,
    ReportesComponent,
    CuentasComponent,
    ContratosComponent,
    EjecucionComponent,
  ],
  imports: [
    CommonModule,
    ComercializacionRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentesModule,
    DialogModule,
    ButtonModule,
    PanelModule,
    CardModule,
    TooltipModule,
    ProgressBarModule,
    DropdownModule
  ],
  exports: [],
})
export class ComecializacionModule { }
